import React, {RefObject} from 'react';
import './PaymentCalendar.css'
import {withTranslation} from "react-i18next";
import {
    ICalendarTotals,
} from "../../models/ISettlementData";
import AccordionHeader from "react-bootstrap/AccordionHeader";
import Accordion from "react-bootstrap/Accordion";
import {Card} from "react-bootstrap";
import AccordionBody from "react-bootstrap/AccordionBody";
import {CurrencyHelper} from "../../helpers/CurrencyHelper";
import {WebCache} from "../../services/WebCache";



interface IState {
    settlementAccordionRef:RefObject<any>
    pressentedAccordionRef:RefObject<any>
    balanceAccordionRef:RefObject<any>

}

interface IProps{
    title: string,
    totals: ICalendarTotals
}
class CalendarTotal extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {

            settlementAccordionRef:React.createRef(),
            pressentedAccordionRef:React.createRef(),
            balanceAccordionRef:React.createRef(),
        }
    }

    componentDidMount() {

    }

    componentWillUnmount() {


    }


    render() {

        // @ts-ignore
        const { t } = this.props;
        const formatCurrency = (amount: number): string => CurrencyHelper.formatCurrencyAmount(this.props.totals.currency, amount);
        return (

            <div className="card">
                <div className="card-header pb-2">
                    <h4 className='fw-bold'>{this.props.title}</h4>
                </div>
                <div className="card-body calendar-side-acordions pt-0">
                    <Accordion defaultActiveKey="none" hidden={true || this.props.totals.balanceAmount==0}>
                        <AccordionHeader ref={this.state.pressentedAccordionRef} >
                            <ul>
                                <li className="calendar-side-acordions-title">{t("presentedCalendarTitle")}</li>
                                <li className="calendar-side-acordions-amount">{formatCurrency(this.props.totals.presentedAmount)}</li>
                            </ul>
                        </AccordionHeader>
                        <AccordionBody>
                            <table className="table calendar-total-detail">
                                <tbody>
                                <tr>
                                    <td>{t("grossAmount")}</td>
                                    <td>{formatCurrency(this.props.totals.presentedGrossAmount)}</td>
                                </tr>
                                <tr className="bg-gray-lightest">
                                    <td>{t("otherCharges")}</td>
                                    <td className="text-danger">{formatCurrency(this.props.totals.presentedChargeAmount)}</td>
                                </tr>
                                <tr>
                                    <td>{t("contrapartsAmount")}</td>
                                    <td className="text-danger">{formatCurrency(this.props.totals.presentedContapartAmount)}</td>
                                </tr>
                                <tr className="bg-gray-lightest">
                                    <td>{t("othersDiscountsAmount")}</td>
                                    <td className="text-danger">{formatCurrency(this.props.totals.presentedOthersAmount)}</td>
                                </tr>
                                <tr>
                                    <td>{(t("total")+"").toUpperCase()}</td>
                                    <td >{formatCurrency(this.props.totals.presentedAmount)}</td>
                                </tr>
                                </tbody>
                            </table>
                        </AccordionBody>
                    </Accordion>
                    <Accordion defaultActiveKey="filter">
                        <AccordionHeader ref={this.state.settlementAccordionRef} >
                            <ul>
                                <li className="calendar-side-acordions-title">{t("settlementCalendarTitle")}</li>
                                <li className="calendar-side-acordions-amount">{formatCurrency(this.props.totals.settlementAmount)}</li>
                            </ul>
                        </AccordionHeader>
                        <AccordionBody>
                            <table className="table calendar-total-detail" hidden={this.props.totals.couponsMovementsSum == 0}>
                                <tbody>
                                <tr className="bg-gray-lightest" hidden={this.props.totals.couponsMovementsSum == 0}>
                                    <td>{t("couponsMovementsSum")}</td>
                                    <td className={this.props.totals.couponsMovementsSum<0?"text-danger":""} >{formatCurrency(this.props.totals.couponsMovementsSum)}</td>
                                </tr>
                                 <tr   hidden={this.props.totals.dtoLawSum == 0}>
                                    <td>{t("dtoLawSum")}</td>
                                    <td className={this.props.totals.dtoLawSum<0?"text-danger":""} >{formatCurrency(this.props.totals.dtoLawSum)}</td>
                                </tr>
                                  <tr  hidden={(this.props.totals.settlementContapartAmount+this.props.totals.addAmountContrapartsMovementsSum) == 0}>
                                    <td>{t("contrapartsAmount")}</td>
                                    <td className={(this.props.totals.settlementContapartAmount+this.props.totals.addAmountContrapartsMovementsSum)<0?"text-danger":""} >{formatCurrency(this.props.totals.settlementContapartAmount+this.props.totals.addAmountContrapartsMovementsSum)}</td>
                                </tr>
                                <tr  hidden={this.props.totals.netSaleFinancialDiscount == 0}>
                                    <td>{t("netSaleFinancialDiscount")}</td>
                                    <td className={(this.props.totals.netSaleFinancialDiscount*-1<0)?"text-danger":""} >{formatCurrency(this.props.totals.netSaleFinancialDiscount*-1)}</td>
                                </tr>
                                 <tr  hidden={this.props.totals.settlementTariffAmount == 0}>
                                    <td>{t("tariffAmount")}</td>
                                    <td className={(this.props.totals.settlementTariffAmount*-1)<0?"text-danger":""} >{formatCurrency(this.props.totals.settlementTariffAmount*-1)}</td>
                                </tr>
                                 <tr   hidden={this.props.totals.settlementTaxAmount == 0}>
                                    <td>{t("taxAmount")}</td>
                                    <td className={(this.props.totals.settlementTaxAmount*-1)-this.props.totals.dtoLawSum<0?"text-danger":""} >{formatCurrency((this.props.totals.settlementTaxAmount*-1)-this.props.totals.dtoLawSum)}</td>
                                </tr>                                 
                                 <tr  hidden={Math.abs(this.props.totals.settlementOthersAmount) < 0.1}>
                                    <td>{t("othersDiscountsAmount")}</td>
                                    <td className={this.props.totals.settlementOthersAmount<0?"text-danger":""} >{formatCurrency(this.props.totals.settlementOthersAmount)}</td>
                                </tr>
                                <tr  hidden={this.props.totals.addAmountCouponsMovementsSum == 0}>
                                    <td>{t("addAmountCouponsMovementsSum")}</td>
                                    <td className={this.props.totals.addAmountCouponsMovementsSum<0?"text-danger":""} >{formatCurrency(this.props.totals.addAmountCouponsMovementsSum)}</td>
                                </tr>
                                <tr className="bg-gray-lightest" >
                                    <td>{(t("total") + "").toUpperCase()}</td>
                                    <td className={this.props.totals.settlementAmount<0?"text-danger":""} >{formatCurrency(this.props.totals.settlementAmount)}</td>
                                </tr>
                                </tbody>
                            </table>
                            <table className="table calendar-total-detail" hidden={this.props.totals.couponsMovementsSum != 0}>
                                <tbody>
                                <tr>
                                    <td>{t("grossAmount")}</td>
                                    <td>{formatCurrency(this.props.totals.settlementGrossAmount)}</td>
                                </tr>
                                <tr className="bg-gray-lightest" hidden={this.props.totals.settlementChargeAmount == 0}>
                                    <td>{t("otherCharges")}</td>
                                    <td className="text-danger">{formatCurrency(this.props.totals.settlementChargeAmount)}</td>
                                </tr>
                                <tr hidden={this.props.totals.settlementTariffAmount == 0}>
                                    <td>{t("tariffAmount")}</td>
                                    <td className="text-danger">{formatCurrency(this.props.totals.settlementTariffAmount)}</td>
                                </tr>
                                <tr hidden={this.props.totals.settlementContapartAmount == 0}>
                                    <td>{t("contrapartsAmount")}</td>
                                    <td className="text-danger">{formatCurrency(this.props.totals.settlementContapartAmount)}</td>
                                </tr>
                                <tr className="bg-gray-lightest">
                                    <td>{t("othersDiscountsAmount")}</td>
                                    <td className="text-danger">{formatCurrency(this.props.totals.settlementOthersAmount)}</td>
                                </tr>
                                <tr>
                                    <td>{t("taxAmount")}</td>
                                    <td className="text-danger">{formatCurrency(-Math.abs(this.props.totals.settlementTaxAmount))}</td>
                                </tr>
                                <tr>
                                    <td>{(t("total") + "").toUpperCase()}</td>
                                    <td>{formatCurrency(this.props.totals.settlementAmount)}</td>
                                </tr>
                                </tbody>
                            </table>
                        </AccordionBody>
                    </Accordion>
                    <Accordion defaultActiveKey="filter" hidden={true||this.props.totals.balanceAmount == 0}>
                        <AccordionHeader ref={this.state.balanceAccordionRef} >
                            <ul>
                                <li className="calendar-side-acordions-title">{t("balanceCalendarTitle")}</li>
                                <li className="calendar-side-acordions-amount">{formatCurrency(this.props.totals.balanceAmount)}</li>
                            </ul>
                        </AccordionHeader>
                        <AccordionBody>
                            <table className="table calendar-total-detail">
                                <tbody>
                                <tr>
                                    <td>{t("presentedCalendarTitle")}</td>
                                    <td>{formatCurrency(this.props.totals.presentedAmount)}</td>
                                </tr>
                                <tr className="bg-gray-lightest">
                                    <td>{t("settlementCalendarTitle")}</td>
                                    <td>{formatCurrency(this.props.totals.settlementAmount)}</td>
                                </tr>
                                <tr>
                                    <td>{(t("balanceCalendarTitle")+"").toUpperCase()}</td>
                                    <td >{formatCurrency(this.props.totals.balanceAmount)}</td>
                                </tr>
                                </tbody>
                            </table>
                        </AccordionBody>
                    </Accordion>

                </div>
            </div>
        )
    };



}
export default withTranslation() (CalendarTotal);
